import { createStore } from "vuex";
import createPersistedState from "vuex-persistedstate";
import Auth from '@/store/module/auth';

//export const store = createStore({
export default createStore({
    modules: {
        auth: Auth,
    },

    plugins: [
        createPersistedState({
            paths: ["auth"],
        })
    ]
})